module.exports = __webpack_public_path__ + "static/media/service-04.614ecace.png";